if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      constructor() {
        super();
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        if (!this.tabs.length || !this.panels.length) return;

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activateTab(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        const activeIndex = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        this.activateTab(activeIndex >= 0 ? activeIndex : 0);
      }

      activateTab(index) {
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          const panel = this.panels[tabIndex];
          tab.setAttribute('aria-selected', selected);
          tab.tabIndex = selected ? 0 : -1;
          if (panel) {
            panel.hidden = !selected;
            panel.classList.toggle('is-active', selected);
          }
        });
      }

      onKeydown(event, index) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;

        this.activateTab(nextIndex);
        this.tabs[nextIndex].focus();
      }
    }
  );
}
